var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, PropSync, Vue } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import { Group } from '@/models/Group';
import { Generate } from '@/models/Generate';
import { DateTime } from 'luxon';
// Dialog imports
import AttachGraduationProfileDialog from '@/views/Groups/Tabs/Actions/Dialogs/AttachGraduationProfileDialog/AttachGraduationProfileDialog.vue';
import RemovePlpDialog from '@/views/Groups/Tabs/Actions/Dialogs/RemovePlpDialog/RemovePlpDialog.vue';
import DownloadPlpDialog from '@/views/Groups/Tabs/Actions/Dialogs/DownloadPlpDialog/DownloadPlpDialog.vue';
import CreatePlpDialog from '@/views/Groups/Tabs/Actions/Dialogs/CreatePlpDialog/CreatePlpDialog.vue';
import AddSkillSetDialog from '@/views/Groups/Tabs/Actions/Dialogs/AddSkillSetDialog/AddSkillSetDialog.vue';
import AddStudentDocumentDialog from '@/views/Groups/Tabs/Actions/Dialogs/AddStudentDocumentDialog/AddStudentDocumentDialog.vue';
import AddDocumentDialog, { DocumentEntityType, } from '@/components/AddDocumentDialog/AddDocumentDialog.vue';
import DownloadThisIsMeDialog from '@/views/Groups/Tabs/Actions/Dialogs/DownloadThisIsMeDialog/DownloadThisIsMeDialog.vue';
let Actions = class Actions extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.DocumentEntityType = DocumentEntityType;
        this.groupId = this.$route.params.id;
        this.isLoading = true;
        this.generateModel = new Generate();
        this.syncTime = '';
        this.generateTime = '';
        this.showRemovePlp = false;
        this.showDownloadPlp = false;
        this.showCreatePlp = false;
        this.showAddSkillSet = false;
        this.showStudentDocument = false;
        this.showGroupDocument = false;
        this.showDownloadThisIsMe = false;
        this.actionCategories = [
            {
                label: this.$tc('Generate'),
                actions: [
                    {
                        label: this.$tc('idp.generate.title', 2),
                        description: this.$tc('Use this button to automatically generate learning objectives for students who are linked to a main and/or sub-area, but for whom the objectives are not yet visible in the PLP. Note: it may be that the learning objectives are already set to "achieved" or "closed" and therefore not visible. In that case, turn on the statuses "achieved" and "closed" in the filter to make them visible.'),
                        actionText: this.$tc('idp.generate.button'),
                        action: async () => {
                            await this.generate();
                        },
                    },
                    {
                        label: this.$tc('idp.synchronize.title', 2),
                        description: this.$tc('Use this button when one or more students are linked to a goal set, but the learning objectives are not visible in their PLP. Note: it may be that the learning objectives are already set to "achieved" or "closed" and therefore not visible. In that case, turn on the statuses "achieved" and "closed" in the filter to make them visible.'),
                        actionText: this.$tc('idp.synchronize.button'),
                        action: () => {
                            this.syncGoalsets();
                        },
                    },
                ],
            },
            {
                label: this.$tc('Add'),
                actions: [
                    {
                        label: this.$tc('Add learning objectives to PLP'),
                        description: this.$tc('Select students and manually add learning objectives to their PLP.'),
                        actionText: this.$tc('actions.add', 1),
                        action: () => {
                            this.onCreatePlp();
                        },
                    },
                    {
                        label: this.$tc('Add skill set'),
                        description: this.$tc('Select one or more skill sets and link them to one or more students. These will then be displayed on the "this is me" page of the student.'),
                        actionText: this.$tc('actions.add', 1),
                        action: () => {
                            this.onAddSkillSet();
                        },
                    },
                    {
                        label: this.$tc('Add document to a student'),
                        description: this.$tc('Create a document for a specific student.'),
                        actionText: this.$tc('actions.add', 1),
                        action: () => {
                            this.onStudentDocument();
                        },
                    },
                    {
                        label: this.$tc('Add document to a group'),
                        description: this.$tc('Create a document for the entire group.'),
                        actionText: this.$tc('actions.add', 1),
                        action: () => {
                            this.onGroupDocument();
                        },
                    },
                ],
            },
            {
                label: this.$tc('Download'),
                actions: [
                    {
                        label: this.$tc('downloadDialog.header.title'),
                        description: this.$tc('Select students to receive their learning objectives booklets by email.'),
                        actionText: this.$tc('actions.download', 1),
                        action: () => {
                            this.onDownloadPlp();
                        },
                    },
                    {
                        label: this.$tc('Download "This is me" in portfolio'),
                        description: this.$tc('Select one or more students, give the document a name, and download it in the portfolio archive on the "this is me" page.'),
                        actionText: this.$tc('download'),
                        action: () => {
                            this.onDownloadThisIsMe();
                        },
                    },
                ],
            },
            {
                label: this.$tc('Delete'),
                actions: [
                    {
                        label: this.$tc('removeDialog.header.title'),
                        description: this.$tc('Remove learning objectives from the PLP of one student or the entire group.'),
                        actionText: this.$tc('actions.delete', 1),
                        action: () => {
                            this.onRemovePlp();
                        },
                    },
                ],
            },
        ];
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        // this.isLoading = true;
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    onSubmitted(key) {
        switch (key) {
            case 'removePlp':
                this.showRemovePlp = false;
                break;
            case 'downloadPlp':
                this.showDownloadPlp = false;
                this.$store.dispatch('openDialog', this.downloadPlpSuccessDialogOptions);
                return;
            case 'createPlp':
                this.showCreatePlp = false;
                break;
            case 'addSkillSet':
                this.showAddSkillSet = false;
                break;
            case 'studentDocument':
                this.showStudentDocument = false;
                break;
            case 'groupDocument':
                this.showGroupDocument = false;
                this.$store.dispatch('openDialog', this.groupDocumentSuccessDialogOptions);
                return;
            case 'downloadThisIsMe':
                this.showDownloadThisIsMe = false;
                this.$store.dispatch('openDialog', this.downloadPlpSuccessDialogOptions);
                return;
        }
        this.$store.dispatch('openDialog', this.successDialogOptions);
    }
    onRemovePlp() {
        this.showRemovePlp = true;
    }
    onDownloadPlp() {
        this.showDownloadPlp = true;
    }
    onCreatePlp() {
        this.showCreatePlp = true;
    }
    onAddSkillSet() {
        this.showAddSkillSet = true;
    }
    onStudentDocument() {
        this.showStudentDocument = true;
    }
    onGroupDocument() {
        this.showGroupDocument = true;
    }
    onDownloadThisIsMe() {
        this.showDownloadThisIsMe = true;
    }
    syncGoalsets() {
        this.$store.dispatch('openDialog', this.dialogOptionsSyncGoalsets);
    }
    // #endregion
    // #region Async methods (api calls only)
    async generate() {
        this.isLoading = true;
        await this.generateModel
            .create()
            .then(() => {
            this.syncTime = DateTime.local().toString();
            this.$store.dispatch('openDialog', this.successDialogOptions);
        })
            .catch((error) => {
            if (!this.generateTime.length) {
                this.syncTime = DateTime.local().toString();
            }
            ErrorHandler.network(error);
        })
            .finally(() => {
            this.isLoading = false;
        });
    }
    get dialogOptionsSyncGoalsets() {
        return {
            title: this.$tc('dialogOptions.confirmation'),
            text: this.$tc('dialogOptions.sync_warning_goals_sets'),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.ok'),
                    action: async () => {
                        this.isLoading = true;
                        await new Generate()
                            .syncGoalsets()
                            .then(() => {
                            this.$store.dispatch('openDialog', this.successDialogOptions);
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        })
                            .finally(() => {
                            this.isLoading = false;
                        });
                    },
                },
                cancel: {
                    text: this.$tc('dialogOptions.button.cancel'),
                },
            },
        };
    }
    // #endregion
    // #region Getters & Setters
    get successDialogOptions() {
        return {
            title: this.$tc('Action completed'),
            text: this.$tc('Action completed successfully'),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.ok'),
                },
            },
        };
    }
    get downloadPlpSuccessDialogOptions() {
        return {
            title: this.$tc('Action completed'),
            text: this.$tc('The student booklets are generated and emailed to you as soon as they are ready. This may take several minutes.'),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.ok'),
                },
            },
        };
    }
    get groupDocumentSuccessDialogOptions() {
        return {
            title: this.$tc('Success'),
            text: this.$tc('Document successfully added'),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.ok'),
                },
            },
        };
    }
};
__decorate([
    PropSync('group'),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], Actions.prototype, "syncedGroup", void 0);
Actions = __decorate([
    Component({
        components: {
            AttachGraduationProfileDialog,
            RemovePlpDialog,
            DownloadPlpDialog,
            CreatePlpDialog,
            AddSkillSetDialog,
            AddStudentDocumentDialog,
            AddDocumentDialog,
            DownloadThisIsMeDialog,
        },
    })
], Actions);
export default Actions;
// #endregion
// #region Constants
// #endregion
